jQuery(document).ready(function ($) {

    $('.accordeon__item').on('click', '.main-title', function () {
        $(this)
            .toggleClass('active')
            .next()
            .stop().slideToggle()
    });
});
